import 'jquery';
$('.subcategory-open-click').on('click', function () {
    const $subcategory = $(this);
    const subcategoryQuestions = $subcategory.next();
    const subcategoryOpenIcon = $subcategory.find('.subcategory-open');
    if (subcategoryQuestions.is(':visible')) {
        subcategoryQuestions.hide();
        subcategoryOpenIcon.removeClass('glyphicon-minus-sign').addClass('glyphicon-plus-sign');
    } else {
        subcategoryQuestions.show();
        subcategoryOpenIcon.removeClass('glyphicon-plus-sign').addClass('glyphicon-minus-sign');
    }
});
